const data = [
    { id: "", name: "Todos" }, 
    { id: 1, name: "Presente" },
    { id: 2, name: "Ausente" },
]
  
export default [...data]